export default __webpack_public_path__ + "9465e72b7c27ae72a5a66591cee68e22.svg";